<template>
    <div class="lg:flex lg:flex-auto lg:flex-col">
        <EmptyState
            v-if="Object.keys(groupEvents).length === 0 && hasSearchQuery"
            icon="bed"
            title="No Award Availability for These Days"
            description="Try to choose another date range or view"
            :show-animation="false"
            action-label="View All Availability"
            @action="gotoAllAvailability()"
        />
        <EmptyState
            v-if="!hasSearchQuery"
            icon="calendar"
            title="Select travel dates"
            description="Add your travel dates and search for the best rooms available for awards."
            :hasAction="false"
        />

        <div class="py-4" v-if="Object.keys(groupEvents).length > 0">
            <h3
                class="text-md font-medium leading-6 text-gray-900 flex md:gap-2 md:items-center md:flex-row flex-col justify-start"
            >
                <span>
                    {{ title }}
                </span>
                <LastUpdated />
            </h3>
        </div>

        <ul role="list" v-if="groupEvents">
            <li
                class="relative flex flex-wrap py-4 border-b border-slate-200 last:border-0"
                v-for="(day, dIndex) in groupEvents"
                :key="'day-' + dIndex"
            >
                <div class="w-full md:w-1/4 pt-3">
                    <p class="text-base leading-6 text-slate-500">
                        {{ day.date }}
                    </p>
                </div>
                <div class="flex w-full md:w-3/4">
                    <ol class="w-full flex flex-col divide-y divide-slate-200">
                        <ListItem
                            :event="event"
                            v-for="(event, eIndex) in day.events"
                            :key="'event-' + eIndex"
                        />
                    </ol>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import LastUpdated from '@/components/calendar/partials/last-updated/last-updated.vue';
import ListItem from '@/components/calendar/partials/list-item.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import dayjs from 'dayjs';

export default {
    name: 'CalendarListRange',
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
        hidePastDates: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        LastUpdated,
        ListItem,
        EmptyState,
    },
    data: () => ({}),
    computed: {
        ...mapState(useCalendarStore, [
            'loading',
            'activeDate',
            'events',
            'startDate',
            'endDate',
            'nights',
            'setTab',
        ]),
        title() {
            if (!this.startDate) {
                return '';
            }

            return `${this.nights} night${this.nights === 1 ? '' : 's'}, ${dayjs(this.startDate).format('MMM D')} -
                    ${dayjs(this.endDate).format('MMM D, YYYY')}`;
        },
        groupEvents() {
            let events = {};
            this.events?.forEach((event) => {
                let pastDate = dayjs(event.start_date).isBefore(dayjs(), 'day');
                if (pastDate && this.hidePastDates) {
                    return;
                }
                let sDate = dayjs(event.start_date).format('ddd, MMM D');
                if (events[event.start_timestamp]) {
                    events[event.start_timestamp].events.push(event);
                } else {
                    events[event.start_timestamp] = {
                        date: sDate,
                        events: [event],
                    };
                }
            });

            return events;
        },
        hasSearchQuery() {
            return this.startDate && this.endDate;
        },
    },
    methods: {
        ...mapActions(useCalendarStore, ['setLoading', 'gotoAllAvailability']),
    },
};
</script>
